import React from 'react';

import styles from './InfoBoxes.less';

export default function InfoBoxes() {
  return (
    <div className="grid-item one-whole margin-top-xxl">
      <div className={`grid padding-horizontal-xl ${styles.infoBoxMain}`}>
        <div className="grid-item one-whole headline-text margin-top-xxl palm-margin-top-l">
          <p className="margin-bottom-xl font-center font-regular font-h3 font-bold margin-top-xl">
            Alles über Ihre Immobilie
          </p>
        </div>
        <div className="grid-item">
          <div className="grid comb-container">
            <div
              id="demographicComb"
              className="grid-item desk-one-third lap-one-third palm-one-whole align-center infobox"
            >
              <div id="demographic-comb" className="slide-in-fwd-center demographic-comb" />
              <p className="padding-bottom-s headline-cosma font-bold font-h5 font-regular">
                Wer wohnt in dem Gebäude?
              </p>
              <p className="description padding-right-m padding-left-m font-regular">
                Erfahren Sie mehr über das Alter, die Wohndauer und den Familienstand der an einer Adresse wohnenden
                Personen.
              </p>
            </div>
            <div
              id="realEstatesComb"
              className="grid-item desk-one-third lap-one-third palm-one-whole align-center infobox"
            >
              <div id="real-estates-comb" className="slide-in-fwd-center real-estates-comb" />
              <p className="padding-bottom-s headline-cosma font-bold font-h5 font-regular">
                Wurde die Immobilie bereits inseriert?
              </p>
              <p className="description padding-right-m padding-left-m font-regular">
                Entdecken Sie alle Inserate von ImmoScout24 der letzten 7 Jahre passend zu dieser Adresse.
              </p>
            </div>

            <div id="trendComb" className="grid-item desk-one-third lap-one-third palm-one-whole align-center infobox">
              <div id="trend-comb" className="slide-in-fwd-center trend-comb" />
              <p className="padding-bottom-s headline-cosma font-bold font-h5 font-regular">
                Wie haben sich die Preise entwickelt?
              </p>
              <p className="description padding-right-m padding-left-m font-regular">
                Verfolgen Sie die Preisentwicklung der letzten 4 Jahre für Immobilien zur Miete oder zum Kauf.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
